import { createAsyncAction } from './creator';

export const MT_GET_ACCOUNT_TYPE = 'MT_GET_ACCOUNT_TYPE';
export const MT_GET_SERVER_LIST = 'MT_GET_SERVER_LIST';
export const MT_GET_SERVER_ACCOUNT_TYPE = 'MT_GET_SERVER_ACCOUNT_TYPE';

export const MT_GET_USED_TRADE_PLATFORM = 'MT_GET_USED_TRADE_PLATFORM';
export const MT_GET_SERVER = 'MT_GET_SERVER';
export const MT_GET_ALIAS = 'MT_GET_ALIAS';
export const MT_GET_CONFIG = 'MT_GET_CONFIG';
export const MT_GET_VIRTUAL_GROUP = 'MT_GET_VIRTUAL_GROUP';

export const getAccountType = createAsyncAction(MT_GET_ACCOUNT_TYPE);
export const getServerList = createAsyncAction(MT_GET_SERVER_LIST);
export const getServerAccountType = createAsyncAction(MT_GET_SERVER_ACCOUNT_TYPE);
export const getUsedTradePlatform = createAsyncAction(MT_GET_USED_TRADE_PLATFORM);
export const getServer = createAsyncAction(MT_GET_SERVER);
export const getAlias = createAsyncAction(MT_GET_ALIAS);
export const getMtConfig = createAsyncAction(MT_GET_CONFIG);
export const getVirtualGroup = createAsyncAction(MT_GET_VIRTUAL_GROUP);
